<div class="fixed inset-0 z-[9999] flex items-center justify-center bg-black/70" (click)="$event.stopPropagation()"
  (keydown.escape)="$event.preventDefault()">
  <div class="w-full max-w-md mx-4 bg-neutral-800 rounded-3xl shadow-xl p-6 md:p-8">
    <div class="text-center mb-2">
      <h2 class="text-2xl font-bold text-white">Date of Birth Required</h2>
    </div>

    <div class="text-center mb-6">
      <p class="text-neutral-300">
        Please enter your date of birth to continue.
      </p>
    </div>

    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="w-full">
      <fieldset [disabled]="isBusy()">
        <div class="pb-4 form-field">
          <label class="text-sm font-semibold text-neutral-200 mb-1 block">Date of Birth</label>
          <app-form-date-field formControlName="birth_date" placeholder="DD/MM/YYYY"
            min="1900-01-01" [max]="maxBirthDate"
            [ariaInvalid]="birthDateControl.invalid && birthDateControl.touched"
            [ariaDescribedby]="'birthdate-modal-dob-errors'"></app-form-date-field>
          <app-form-validation-errors [control]="birthDateControl" [validationErrors]="{
            required: 'Date of birth is required',
            age: 'You must be at least 18 years old.',
            serverError: birthDateControl.getError('serverError') ?? ''
          }" color="#eb5757"
          id="birthdate-modal-dob-errors"></app-form-validation-errors>
          @if (birthDateControl.hasError('required') && birthDateControl.touched) {
          <p class="dob-note mt-1 border-l-2 border-primary pl-2 text-form-field-label font-bold text-xs tracking-[0.04em]"
             style="font-variant-caps: all-small-caps"
             id="birthdate-modal-dob-note">
            We ask for date of birth as all events are 18+
          </p>
          }
        </div>

        <button type="submit" [disabled]="birthDateControl.invalid" class="primary-button h-14 w-full">
          @if (isBusy()) {
          <app-spinner></app-spinner>
          } @else {
          <span>Submit</span>
          }
        </button>
      </fieldset>
    </form>
  </div>
</div>
